import revive_payload_client_4sVQNw7RlN from "/opt/vims-fe-live/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/opt/vims-fe-live/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/opt/vims-fe-live/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/opt/vims-fe-live/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/opt/vims-fe-live/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_YdLad5Mpq3 from "/opt/vims-fe-live/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/opt/vims-fe-live/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/opt/vims-fe-live/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_Jozdw60ZsE from "/opt/vims-fe-live/node_modules/dayjs-nuxt/dist/runtime/plugin.js";
import plugin_AOuQ1DYzjk from "/opt/vims-fe-live/node_modules/@sidebase/nuxt-auth/dist/runtime/plugin.mjs";
import plugin_ghbUAjaD3n from "/opt/vims-fe-live/node_modules/@nuxtjs/device/dist/runtime/plugin.js";
import chunk_reload_client_UciE0i6zes from "/opt/vims-fe-live/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import index_icV7BkfTNu from "/opt/vims-fe-live/plugins/casl/index.js";
import index_NoOeBbAe38 from "/opt/vims-fe-live/plugins/vuetify/index.js";
import warn_handler_client_Y8ImFt0L5S from "/opt/vims-fe-live/plugins/warn-handler.client.ts";
import index_HYtSsfhyFh from "/opt/vims-fe-live/plugins/iconify/index.js";
import apexcharts_client_xo3MRJYPBX from "/opt/vims-fe-live/plugins/apexcharts.client.js";
import firebase_client_nS52P0yitD from "/opt/vims-fe-live/plugins/firebase.client.js";
import layouts_OBoGUkHiof from "/opt/vims-fe-live/plugins/layouts.js";
import webfontloader_client_Jql8Gs55fp from "/opt/vims-fe-live/plugins/webfontloader.client.js";
import websocket_client_yuEk7YXzOs from "/opt/vims-fe-live/plugins/websocket.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_Jozdw60ZsE,
  plugin_AOuQ1DYzjk,
  plugin_ghbUAjaD3n,
  chunk_reload_client_UciE0i6zes,
  index_icV7BkfTNu,
  index_NoOeBbAe38,
  warn_handler_client_Y8ImFt0L5S,
  index_HYtSsfhyFh,
  apexcharts_client_xo3MRJYPBX,
  firebase_client_nS52P0yitD,
  layouts_OBoGUkHiof,
  webfontloader_client_Jql8Gs55fp,
  websocket_client_yuEk7YXzOs
]